<template>
  <div>
    <h2>{{ title }}</h2>
    <div class="child-table">
      <div class="child-row" v-for="a in attributes" :key="a.name">
        <div class="child-label">{{ a.name }}</div>
        <!-- @vue-skip -->
        <div class="child-value">{{ a.value ?? '--' }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">

export default {
  name: 'ChildAttributes',
  props: {
    title: String,
    attributes: Array as () => { name: string, value: string | number | undefined }[]
  }
};
</script>

<style scoped>
h2 {
  font-size: 0.9rem;
  border-bottom: 1px solid var(--v-border-base);
  margin-bottom: 0.5rem;
}

.child-table {
  display: table;
}

.child-row {
  display: table-row;
}

.child-label, .child-value {
  display: table-cell;
  font-size: 0.9em;
}

.child-label {
  text-align: right;
}

.child-value {
  padding-left: 1rem;
  font-weight: 700;
}
</style>
